import React from 'react';
import { IconProps } from '.';

const SvgZDelivery = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M14.25 5.75H5v-1.5h10.75v5h4.925l3.075 2.924v5.576h-2.76a3 3 0 1 1-5.98 0h-3.02a3 3 0 1 1-5.98 0H4v-1.5h2.563A2.996 2.996 0 0 1 9 15c1.004 0 1.892.493 2.437 1.25h2.813V5.75Zm1.5 10.266V10.75h4.325l2.175 2.067v3.433h-1.813A2.996 2.996 0 0 0 18 15c-.896 0-1.7.393-2.25 1.016ZM9 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM19.5 18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M3 9.75h3v-1.5H3v1.5ZM5 13.75H0v-1.5h5v1.5ZM8.099 9.402V8H12l-1.784 4.595h1.685V14H8l1.797-4.598H8.099Z'
      />
    </svg>
  );
};

export default SvgZDelivery;
